export enum WithdrawalWalletOperationStatus {
    PENDING = "pending",
    FAILED = "failed",
    CANCELED = "canceled",
    COMPLETED = "completed"
}
